import { Box, ListItemText, MenuItem, MenuList } from '@mui/material';
import { ProductStatus } from 'generated/graphql';
import isEqual from 'lodash/isEqual';
import { Count, useStore } from 'react-admin';

export const productStatusFilters: Record<string, Record<string, string>> = {
  All: {},
  Processing: { status: ProductStatus.Processing },
  Submitted: { status: ProductStatus.Submitted },
};

interface ProductStatusFilterOption {
  key: string;
  label: string;
  filter: Record<string, string>;
}

const productStatusFilterOptions: ProductStatusFilterOption[] = [
  { filter: productStatusFilters.All, key: 'ALL', label: 'Všetky' },
  { filter: productStatusFilters.Processing, key: 'PROCESSING', label: 'Spracovávané' },
  { filter: productStatusFilters.Submitted, key: 'SUBMITTED', label: 'Odoslané' },
];

export const ProductListAside: React.FC = () => {
  const [statusFilter, setStatusFilter] = useStore('resources.products.list.statusFilter', productStatusFilters.All);

  return (
    <Box flexShrink={0} mr={1} mt={7} order={-1} width={200}>
      <MenuList>
        {productStatusFilterOptions.map((it) => (
          <MenuItem key={it.key} onClick={() => setStatusFilter(it.filter)} selected={isEqual(statusFilter, it.filter)}>
            <ListItemText>{it.label}</ListItemText>
            <Count color="text.disabled" filter={it.filter} />
          </MenuItem>
        ))}
      </MenuList>
    </Box>
  );
};
